import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Header_3 from '../headers/Header_3';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Formulare from '../modules/Formulare';
import MapComponent from '../components/MapComponent';
import SEO from '../components/Seo';
import LocalMapComponent from '../components/LocalMapComponent';
import GallerySlider from '../components/GallerySlider';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Header_2 from '../headers/Header_2';

export const SiedlungenDetail = () => {

    // useEffect(() => {
    //     const equalHeight = () => {
    //         // 👉 P elements
    //         const paragraphs = document.querySelectorAll(
    //             ".col-full-mobile .col-inner address"
    //         );
    //         let maxP = 0;
    //         paragraphs.forEach((el) => {
    //             el.style.height = "auto";
    //             maxP = Math.max(maxP, el.offsetHeight);
    //         });
    //         paragraphs.forEach((el) => {
    //             el.style.height = maxP + "px";
    //         });
    //     };
    //     // run on load
    //     setTimeout(equalHeight, 300);
    //     // run on resize
    //     window.addEventListener("resize", equalHeight);
    //     return () => {
    //         window.removeEventListener("resize", equalHeight);
    //     };
    // }, []);



    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [formulare, setFormulare] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[neubauprojekte_kategoriens][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.quote][populate]=*&populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Standort][populate]=*&populate[Beitrags_Miniaturbild][populate]=true&populate[Modul][on][modules.facts-modul][populate][Facts][populate][Icon][populate]=*&populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Standort][populate]=*&populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Bild][populate]=true&populate[Metadaten]=*&populate[Modul][on][modules.fakten-siedlung-modul][populate][Fakten_Siedlung][populate][Titel_Text][populate]=*&populate[Modul][on][modules.link-facts-module][populate][Link_Facts][populate][Icon][populate]=*&populate[Modul][on][modules.galerie-siedlung][populate][Bilder][populate]=*");

            // &populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Bild][populate]=true





            // &populate[Modul][on][modules.link-facts-module][populate][Link_Facts][populate][Icon][populate]=*

            // &populate[Modul][on][modules.galerie-siedlung][populate][Bilder][populate]=*

            // Galerie

            // "https://backend.bgzurlinden.ch/api/siedlungens?pagination[limit]=200&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.facts-modul][populate][Facts][populate][Icon][populate]=*&populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Standort][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Metadaten]=*"

            // &populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true

            const data = await response.json();
            console.log(data);

            if (data.data) {
                setFormulare(data.data);
                // setModules(data?.data?.Modul);
                // setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const [formButtons, setFormButtons] = useState([]);

    const getFormButtons = async () => {
        // setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/form-buttons?sort[0]=Titel&populate[orange_Icon][populate]=true&populate[blue_Icon][populate]=true");

            const data = await response.json();
            console.log(data);

            if (data.data) {
                setFormButtons(data.data);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getFormButtons();
        getPageData();
    }, [])

    const [metaData, setMetaData] = useState(null);
    const [standortData, setStandortData] = useState(null);

    useEffect(() => {

        if (formulare?.length > 0 && title) {
            const matchedCategory = formulare?.find((category) => category.slug === title);
            if (matchedCategory) {
                setModules(matchedCategory?.Modul);
                setHeaderModules(matchedCategory?.Bannerbereich);
                setMetaData(matchedCategory?.Metadaten);
                setStandortData(matchedCategory);

            } else {
                navigate("/error"); // Redirect to trigger the catch-all error route
            }
        }


    }, [formulare, title]);


    useEffect(() => {
        const equalHeight = () => {
            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".siedlung-column .eq-height"
            );
            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };
        // run on load
        setTimeout(equalHeight, 800);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, [modules]);

    const imgArr = ["/images/orange-icon-3.svg", "/images/orange-Wohnungen.svg", "/images/orange-icon-1.svg", "/images/orange-Gewerbe.svg"]
    // const imgArr = ["/images/blue-icon-3.svg", "/images/Wohnungen.svg", "/images/blue-icon-1.svg", "/images/Gewerbe.svg"]

    return (
        <div className={`page-content ${headerModules?.[0]?.Titel?.toLowerCase() == "albisriederdörfli, zürich" ? 'page-content-small-font' : ''}`}>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" activeInnerPage="Siedlungen" bgGray={true} sticker={true} />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" activeInnerPage="Siedlungen" />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {/* {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        } */}
                        {/* {module.__component === "modules.facts-modul" &&
                            <section className='sec-orange-color sec-facts'>
                                <div className='container'>
                                    <div className='wohnen-zahlen-fakten'>
                                        <div className='row default-grid-gap mt-lg-4'>
                                            {module?.Facts?.map((item, index) => {

                                                return (
                                                    <div key={index} className='col-6 col-lg-3 mt-4 col-item' style={{ borderBottom: index >= module?.Facts?.length - (module?.Facts?.length % 4 || 4) ? 'none' : '1px solid #CFCFCF' }}>
                                                        <div className='col-inner'>
                                                            <img src={`https://backend.bgzurlinden.ch${item?.Icon?.url}`} alt='Baujahr' />
                                                            <h4 className="fw-450 fs_30">{item?.Titel}</h4>
                                                            <h2 className="text-orange fw-550">{item?.Text}</h2>
                                                        </div>
                                                    </div>
                                                )

                                            })}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        } */}
                        {module.__component === "modules.adresse-modul" &&
                            // <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                            //     <div className='zah_fakten_map'>
                            //         <LocalMapComponent locationData={[standortData]} localAddress={true} markerColor="orange" />
                            //     </div>
                            // </section>

                            <section className="new-blue-fakten pt-pb-10">
                                <div className="container">
                                    <div className="row">
                                        {[standortData]?.map((item, index) => (
                                            <div key={index} className="col-lg-8 align-self-center">
                                                <div className="sec-title">
                                                    <h2 className="fs-50">{item?.Page_Titel}</h2>
                                                    {item?.Standort?.Text?.split("\n").map((line, index) => (
                                                        <span key={index}>
                                                            {line}
                                                            <br />
                                                        </span>
                                                    ))}
                                                </div>
                                                <div className="row">
                                                    {item?.Standort?.Titel_Text?.map((i, ind) => (
                                                        <div key={ind} className="col-6 col-md-3 col-item mt-4">
                                                            <div className="col-inner">
                                                                <img src={imgArr[ind]} />
                                                                <h2 className="fs-30 mt-0">{i?.Titel}</h2>
                                                                <p>
                                                                    {i?.Text?.split("\n").map((line, index) => (
                                                                        <span key={index}>
                                                                            {line}
                                                                            <br />
                                                                        </span>
                                                                    ))}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-lg-4 mt-lg-0 mt-4">
                                            <div className="blue_map">
                                                {/* <img src="/images/map-blue.png" className="w-100" /> */}
                                                <LocalMapComponent locationData={[standortData]} localAddress={true} markerColor="orange" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>



                        }
                        {/* {module.__component === "modules.link-facts-module" &&
                            <section className='pt-pb-10 sec-new-zahlen sec-orange-color'>
                                <div className='container'>
                                    <div className='row'>
                                        {formButtons?.map((item, index) => (
                                            <div key={index} className='col-sm-6 col-lg-4 mb-4 mb-lg-0'>
                                                <Link to={item?.Link} className='col_inner'>
                                                    <div className='icon-icon'>
                                                        <img src={`https://backend.bgzurlinden.ch${item?.orange_Icon?.url}`} />
                                                    </div>
                                                    <div className='text-button'>
                                                        <h3 className='fs_30 mb-2'>{item?.Titel}</h3>
                                                        <p>{item?.Text}</p>
                                                        <span className='btn-circle'>
                                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M24.2676 18.0508C24.2512 18.754 23.6678 19.3374 22.9646 19.3538C22.2614 19.3702 21.7046 18.8134 21.721 18.1102L22.0835 2.57667L6.54995 2.93916C5.84672 2.95557 5.28993 2.39878 5.30635 1.69556C5.32277 0.992338 5.90615 0.408938 6.60937 0.392528L23.4162 0.000367795C24.1194 -0.0160363 24.6762 0.540743 24.6598 1.24397L24.2676 18.0508Z" fill="white" />
                                                                <path d="M2.15282 24.2661C1.64395 24.7749 0.837738 24.7937 0.352084 24.3081C-0.133571 23.8224 -0.114755 23.0162 0.394106 22.5073L22.5071 0.394318C23.016 -0.114544 23.8222 -0.133357 24.3079 0.352297C24.7935 0.837952 24.7747 1.64417 24.2658 2.15303L2.15282 24.2661Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>} */}
                        {module.__component === "modules.formulare-reglemente-dokumente" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <DokumenteSlider formulare={module?.formulares} /> */}
                                    <Formulare formulare={module?.formulares} />
                                </div>
                            </section>
                        }

                        {module.__component === "modules.galerie-siedlung" &&
                            // <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                            <section className='sec-bg-grey pt-pb-10 sec-orange-color overflow-hidden'>
                                <div className='container'>
                                    <GallerySlider images={module?.Bilder} />
                                </div>
                            </section>}

                        {module.__component === "modules.fakten-siedlung-modul" &&
                            <>
                                <section className='sec-bg-grey pt-pb-10 sec-siedlung-umgebung sec-orange-color'>
                                    <div className='container'>
                                        <div className='row line_center_middle'>
                                            {module?.Fakten_Siedlung?.map((item, index) => (
                                                <div className='col-lg-6 siedlung-column'>
                                                    <div className='mb-5'>
                                                        <h2 className='text-black fw-500 mb-lg-4 mb-2'>{item?.Titel}</h2>

                                                        <div className="eq-height">
                                                            {item?.Text && <BlocksRenderer content={item?.Text} />}
                                                        </div>
                                                    </div>

                                                    <div className='mb-4 mb-lg-0'>
                                                        <h3 className='text-black fs_40 fw-600 mb-lg-3 mb-2 title-line-before'>{item?.Untertitel}</h3>
                                                        <table className='w-100 table'>
                                                            {item?.Titel_Text?.map((data, index) => (
                                                                <tr key={index}>
                                                                    <td>{data?.Titel}</td>
                                                                    <td>{data?.Text}</td>
                                                                </tr>
                                                            ))}
                                                        </table>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </section>
                                <section className='pt-pb-10 sec-new-zahlen sec-orange-color'>
                                    <div className='container'>
                                        <div className='row'>
                                            {formButtons?.map((item, index) => (
                                                <div key={index} className='col-sm-6 col-lg-4 mb-4 mb-lg-0'>
                                                    <Link to={item?.Link} className='col_inner'>
                                                        <div className='icon-icon'>
                                                            <img src={`https://backend.bgzurlinden.ch${item?.orange_Icon?.url}`} />
                                                        </div>
                                                        <div className='text-button'>
                                                            <h3 className='fs_30 mb-2'>{item?.Titel}</h3>
                                                            <p>{item?.Text}</p>
                                                            <span className='btn-circle'>
                                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M24.2676 18.0508C24.2512 18.754 23.6678 19.3374 22.9646 19.3538C22.2614 19.3702 21.7046 18.8134 21.721 18.1102L22.0835 2.57667L6.54995 2.93916C5.84672 2.95557 5.28993 2.39878 5.30635 1.69556C5.32277 0.992338 5.90615 0.408938 6.60937 0.392528L23.4162 0.000367795C24.1194 -0.0160363 24.6762 0.540743 24.6598 1.24397L24.2676 18.0508Z" fill="white" />
                                                                    <path d="M2.15282 24.2661C1.64395 24.7749 0.837738 24.7937 0.352084 24.3081C-0.133571 23.8224 -0.114755 23.0162 0.394106 22.5073L22.5071 0.394318C23.016 -0.114544 23.8222 -0.133357 24.3079 0.352297C24.7935 0.837952 24.7747 1.64417 24.2658 2.15303L2.15282 24.2661Z" fill="white" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </section>
                            </>
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

            {!isLoading && <div className='btn-container justify-content-center mt-4 mt-lg-5'>
                <Link to="/siedlungen?id=projekte" className='button round_btn btn-orange-color'>
                    zur Übersicht
                    <span>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                        </svg>
                    </span>
                </Link>
            </div>}
        </div>
    )
}